import React from 'react';
import { connect } from 'react-redux';
import './TransactionsDemo.css';
import * as actions from '../actions.js';

import {
    Grid,
    PageHeader,
    Row,
    Col,
    Form,
    FormGroup,
    Checkbox,
    ControlLabel,
    FormControl,
    Button,
} from 'react-bootstrap';



function UtxoCheckbox({ data }) {
    return <Checkbox className={'utxo sixteencolour' + data.color} title={data.id} checked={data.selected} value={data.id}>
        <div className="utxo-data">
            <span className="utxo-id" title="transaction id">{ data.id }</span>
            <span className="utxo-amount" title="amount">{ data.amount }</span>
            <span className="utxo-lockedby" title="locked by">{ data.lockedBy }</span>
        </div>
    </Checkbox>;
}
function PrivateKeyCheckbox({ data }) {
    return <Checkbox className={'privatekey sixteencolour' + data.color} title={data.name} checked={data.selected} value={data.name}>
        { data.name }
    </Checkbox>;
}

function TxInput({ data }) {
    return <div className={'txinput sixteencolour' + data.color}>
        <div>{data.id}</div>
        {
            data.signed
            ? <div>signed</div>
            : null
        }
    </div>;
}
function TxOutput({ n, data, remove }) {
    return <div className="txoutput">
        <Button bsSize="xsmall" className="txremovebutton" onClick={remove}>X</Button>
        <div className="txoutputnumber">{ n }</div>
        <div>To: adr-{data.address}</div>
        <h4>{data.amount}</h4>
    </div>;
}

function TransactionsDemo({
    utxos,
    keys,
    inputs,
    preparedOutput,
    outputs,
    signingKeys,
    inputTotal,
    outputTotal,
    validTx,
    toggleInput,
    toggleKey,
    updatePreparedOutput,
    addPreparedOutput,
    removeOutput,
}) {
    //TODO: add support for change address
    const preparedOutputColour = (keys.find(x => x.name === 'key-' + preparedOutput.address) || {}).color;
    return (
        <Grid>
            <PageHeader>
                Transaction Creation Demonstration
            </PageHeader>
            <Row>
                <Col sm={6}>
                    <h2>UTXOs</h2>
                    <FormGroup onChange={ev => toggleInput(ev.target.value)}>
                        { utxos.map((x,i) => <UtxoCheckbox data={x} key={'utxo'+i} />) }
                    </FormGroup>
                </Col>
                <Col sm={6}>
                    <h2>Your Private Keys</h2>
                    <FormGroup onChange={ev => toggleKey(ev.target.value)}>
                        { keys.map((x,i) => <PrivateKeyCheckbox data={x} key={'privkey'+i} />) }
                    </FormGroup>
                </Col>
            </Row>
            <Row><h2>Inputs</h2></Row>
            <Row className="txinstructionsrow">
                <Col sm={6}>Select UTXOs as inputs</Col>
                <Col sm={6}>Select keys to sign the transaction</Col>
            </Row>
            <Row className="txinputsrow">
                <Col sm={12}>
                    {
                        inputs.map((x,i) => <TxInput data={x} key={'txinput'+i} />)
                    }
                </Col>
            </Row>
            <Row>
                <h2>Total: {inputTotal}</h2>
            </Row>
            <Row>
                <h2>Outputs</h2>
            </Row>
            <Row>
                <Col sm={6}>
                    {
                        outputs.map((x,i) => <TxOutput n={i} data={x} remove={removeOutput.bind(null, i)} key={'txoutput'+i} />)
                    }
                    <div className="txoutput fees">
                        <div>Fees</div>
                        <h4>{inputTotal - outputTotal}</h4>
                    </div>
                </Col>
                <Col sm={6}>
                    <h3>Add Output</h3>
                    <Form horizontal>
                        <FormGroup onChange={ev => updatePreparedOutput({address:ev.target.value})}>
                            <Col sm={2} componentClass={ControlLabel}>Address</Col>
                            <Col sm={10}>
                                <FormControl type="text" value={preparedOutput.address} className={preparedOutputColour ? 'sixteencolour' + preparedOutputColour : ""} />
                            </Col>
                        </FormGroup>
                        <FormGroup onChange={ev => updatePreparedOutput({amount:ev.target.value})}>
                            <Col sm={2} componentClass={ControlLabel}>Amount</Col>
                            <Col sm={10}><FormControl type="number" value={preparedOutput.amount} min="0" max={inputTotal - outputTotal} /></Col>
                        </FormGroup>
                        <FormGroup>
                            <Col smOffset={2} sm={10}>
                                <Button bsStyle="catallaxy" onClick={addPreparedOutput}>Add</Button>
                            </Col>
                        </FormGroup>
                    </Form>
                </Col>
            </Row>
            <Row className={'txvalidity ' + (validTx ? 'validtx' : 'invalidtx')}>
                {(validTx ? 'valid' : 'invalid')} transaction
            </Row>
        </Grid>
    );
}

function stateToProps({ transaction }) {
    const signingKeys = transaction.keys.filter(x => x.selected),
        inputs = transaction.utxos
            .filter(x => x.selected)
            .map(x => ({...x, signed: signingKeys.find(k => k.name === x.lockedBy) || false})),
        inputTotal = Math.floor(inputs.reduce((s,x) => s+x.amount, 0) * 100000000) / 100000000,
        outputTotal = transaction.outputs.reduce((s,x) => s+x.amount, 0),
        validTx = outputTotal <= inputTotal && inputs.every(x => x.signed); //TODO: consider adding reasons
    return {
        ...transaction,
        inputs,
        signingKeys,
        inputTotal,
        outputTotal,
        validTx,
    };
}
function dispatchToProps(dispatch) {
    return {
        toggleInput(which) {
            dispatch(actions.transactionToggleInput(which));
        },
        toggleKey(which) {
            dispatch(actions.transactionToggleKey(which));
        },
        updatePreparedOutput(values) {
            dispatch(actions.transactionUpdatePreparedOutput(values));
        },
        addPreparedOutput() {
            dispatch(actions.transactionAddOutput());
        },
        removeOutput(index) {
            dispatch(actions.transactionRemoveOutput(index));
        },
    };
}

export default connect(stateToProps, dispatchToProps)(TransactionsDemo);







// WEBPACK FOOTER //
// ./src/components/TransactionsDemo.js